<template>
	<ppe-form 
		entityName="D0"
		title="D0. Sous-traitants" 
		title-field="{operation.code}, {operation.operationname}"
 	  sub-title=""

		:schema="schema" 
		:endpoint="endpoint"
		:redirect="'/ppe_ee/operation_home/:operationid'" 
		>

	</ppe-form>
</template>
<script>
 
import Business from 'ppe-business'
import Utils    from '../ppe/utils'

export default {
	data() {
		console.log("this.$route.params.operationid", this.$route.params.operationid)
		return {
			endpoint : "/ee/d0?id=" + this.$route.params.id+'&operationid='+this.$route.query.operationid+"&companyid="+this.$route.query.companyid,
			schema : [
			{ card: "Sous traitants",
					body : [
						{
							type:'group', repeatable: true,
							name: 'contractors',  label : 'Déclarez vos sous-traitants sur cette opération',
							addLabel: 'Ajouter un sous-traitant', validation : "min:0,length", size:'large',
							children:[
									{ component: 'div', class:'display-inline', children:[
										{name:"name",   		   label:"Nom de l'entreprise",      type: "text",     validation: 'required', class:'col-md-6'},
										{name:"email",   		   label:"Email",                    type: "email",    validation: 'required', class:'col-md-6'},
										{name:"phone",   		   label:"Téléphone",                type: "text",    validation: '', class:'col-md-6'},
										{name:"tasks",   		   label:"Description des tâches ou travaux à exécuter",type: "textarea", validation: '', class:'col-md-6'},
									]}
							]
						},
					]
				},
				
				Utils.getGetManagerCard(),
				Utils.getAdminCard(),
				],

		}
	},

};
</script>
<style>
.display-inline {
	display:   flex;
	flex-wrap: wrap;
}

.formulate-input-element-checkboxtable .formulate-input-label {
	/*white-space:nowrap;*/
	min-width: 40%;
}
</style>
